<template>
  <div>
    <!-- 共通ヘッダー（タイトル/サブタイトル） -->
    <div class="content-header">
      <h1 class="page-title">
        <i class="fas fa-magnifying-glass"></i>
        避難元避難先（避難所）
      </h1>
    </div>
    <error-message :error-object="errorObject" />
    <section>
      <!-- 検索部 -->
      <details :open="isOpen" ref="facility_search_eva_search">
        <summary @click.prevent="toggleOpen">検索条件</summary>
        <div class="content-card compact">
          <div
            class="sample-content"
            style="display:flex; gap:16px; align-items:flex-start; position:relative"
          >
            <div
              style="display:flex; gap:16px; flex-wrap:wrap; align-items:flex-start;"
            >
              <div style="flex-shrink:0;">
                <!-- 避難元市町、地区、自治会検索 -->
                <div style="font-weight:500; color:#666; font-size:14px;">
                  ①避難元の市町、地区、自治会を検索します
                </div>
                <div style="display:flex; align-items:center; gap:12px;">
                  <div class="vtf-field" style="width:120px;">
                    <input
                      v-model="searchFilters.municipName"
                      type="text"
                      placeholder=" "
                      maxlength="30"
                    />
                    <label>市町名</label>
                  </div>
                  <div class="hint">部分一致</div>
                </div>
                <div style="display:flex; align-items:center; gap:12px;">
                  <div class="vtf-field" style="width:120px;">
                    <input
                      v-model="searchFilters.areaName"
                      type="text"
                      placeholder=" "
                      maxlength="40"
                    />
                    <label>地区名</label>
                  </div>
                  <div class="hint">部分一致</div>
                  <div class="vtf-field" style="width:120px;">
                    <input
                      v-model="searchFilters.areaNameKana"
                      type="text"
                      placeholder=" "
                      maxlength="100"
                    />
                    <label>地区名フリガナ</label>
                  </div>
                  <div class="hint">部分一致</div>
                </div>
                <div style="display:flex; align-items:center; gap:12px;">
                  <div class="vtf-field" style="width:120px;">
                    <input
                      v-model="searchFilters.autonomyName"
                      type="text"
                      placeholder=" "
                      maxlength="50"
                    />
                    <label>自治会名</label>
                  </div>
                  <div class="hint">部分一致</div>
                  <div class="vtf-field" style="width:120px;">
                    <input
                      v-model="searchFilters.autonomyNameKana"
                      type="text"
                      placeholder=" "
                      maxlength="50"
                    />
                    <label>自治会名フリガナ</label>
                  </div>
                  <div class="hint">部分一致</div>
                </div>
                <div style="display:flex; align-items:center; gap:12px;">
                  <div style="font-weight:500; color:#666; font-size:12px;">
                    自治会人口
                  </div>
                  <div class="range-field">
                    <input
                      v-model="searchFilters.populationFrom"
                      type="text"
                      name="populationFrom"
                      maxlength="4"
                      autocomplete="off"
                      @input="validateInteger"
                    />
                    <span>〜</span>
                    <input
                      v-model="searchFilters.populationTo"
                      type="text"
                      name="populationTo"
                      maxlength="4"
                      autocomplete="off"
                      @input="validateInteger"
                    />
                    <span>人</span>
                  </div>
                </div>
                <div style="display:flex; align-items:center; gap:12px;">
                  <div style="font-weight:500; color:#666; font-size:12px;">
                    自治会世帯数
                  </div>
                  <div class="range-field">
                    <input
                      v-model="searchFilters.householdsCountFrom"
                      type="text"
                      name="householdsCountFrom"
                      maxlength="4"
                      autocomplete="off"
                      @input="validateInteger"
                    />
                    <span>〜</span>
                    <input
                      v-model="searchFilters.householdsCountTo"
                      type="text"
                      name="householdsCountTo"
                      maxlength="4"
                      autocomplete="off"
                      @input="validateInteger"
                    />
                    <span>世帯</span>
                  </div>
                </div>
              </div>

              <!-- 集合場所検索 -->
              <div style="flex-shrink:0; margin-left:20px;">
                <div style="font-weight:500; color:#666; font-size:14px;">
                  ②集合場所を検索します
                </div>
                <div style="display:flex;">
                  <div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div class="vtf-field" style="width:120px;">
                        <input
                          v-model="searchFilters.faName"
                          type="text"
                          placeholder=" "
                          maxlength="40"
                        />
                        <label>施設名</label>
                      </div>
                      <div class="hint">部分一致</div>
                    </div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div class="vtf-field" style="width:120px;">
                        <input
                          v-model="searchFilters.faAddress"
                          type="text"
                          placeholder=" "
                          maxlength="40"
                        />
                        <label>住所</label>
                      </div>
                      <div class="hint">部分一致</div>
                    </div>
                    <div style="margin:1px 0;">
                      <div
                        style="margin-bottom:4px; font-weight:500; color:#666; font-size:12px;"
                      >
                        原発からの直線距離
                      </div>
                      <div class="range-field" style="margin-left: 10px;">
                        <input
                          v-model="searchFilters.distanceFrom"
                          type="text"
                          name="distanceFrom"
                          maxlength="6"
                          autocomplete="off"
                          @input="validateRange"
                        />
                        <span>〜</span>
                        <input
                          v-model="searchFilters.distanceTo"
                          type="text"
                          name="distanceTo"
                          maxlength="6"
                          autocomplete="off"
                          @input="validateRange"
                        />
                        <span>km</span>
                      </div>
                    </div>
                  </div>
                  <div
                    style="display:flex; flex-direction:column; gap:4px; align-items:center; margin-left:20px;"
                  >
                    <div style="font-weight:500; color:#666; font-size:12px;">
                      原発からの方角（複数可）
                    </div>
                    <SelectDirection ref="selectDirection" />
                  </div>
                </div>
              </div>

              <!-- 避難先検索 -->
              <div style="flex-shrink:0; margin-left:20px;">
                <div style="font-weight:500; color:#666; font-size:14px;">
                  ③避難先を検索します
                </div>
                <div style="display:flex;">
                  <div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div class="vtf-field" style="width:120px;">
                        <input
                          v-model="searchFilters.evaFaName"
                          type="text"
                          placeholder=" "
                          maxlength="40"
                        />
                        <label>施設名</label>
                      </div>
                      <div class="hint">部分一致</div>
                    </div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div class="vtf-field" style="width:120px;">
                        <input
                          v-model="searchFilters.evaFaAddress"
                          type="text"
                          placeholder=" "
                          maxlength="40"
                        />
                        <label>住所</label>
                      </div>
                      <div class="hint">部分一致</div>
                    </div>
                    <div style="margin:1px 0;">
                      <div
                        style="margin-bottom:4px; font-weight:500; color:#666; font-size:12px;"
                      >
                        収容人数
                      </div>
                      <div class="range-field" style="margin-left: 10px;">
                        <input
                          v-model="searchFilters.evaMaxCapacityFrom"
                          type="text"
                          name="evaMaxCapacityFrom"
                          maxlength="4"
                          autocomplete="off"
                          @input="validateInteger"
                        />
                        <span>〜</span>
                        <input
                          v-model="searchFilters.evaMaxCapacityTo"
                          type="text"
                          name="evaMaxCapacityTo"
                          maxlength="4"
                          autocomplete="off"
                          @input="validateInteger"
                        />
                        <span>人</span>
                      </div>
                    </div>
                    <div style="margin:1px 0;">
                      <div
                        style="margin-bottom:4px; font-weight:500; color:#666; font-size:12px;"
                      >
                        原発からの直線距離
                      </div>
                      <div class="range-field" style="margin-left: 10px;">
                        <input
                          v-model="searchFilters.evaDistanceFrom"
                          type="text"
                          name="evaDistanceFrom"
                          maxlength="6"
                          autocomplete="off"
                          @input="validateRange"
                        />
                        <span>〜</span>
                        <input
                          v-model="searchFilters.evaDistanceTo"
                          type="text"
                          name="evaDistanceTo"
                          maxlength="6"
                          autocomplete="off"
                          @input="validateRange"
                        />
                        <span>km</span>
                      </div>
                    </div>
                  </div>
                  <div
                    style="display:flex; flex-direction:column; gap:4px; align-items:center; margin-left:20px;"
                  >
                    <div style="font-weight:500; color:#666; font-size:12px;">
                      原発からの方角（複数可）
                    </div>
                    <SelectDirection ref="evaSelectDirection" />
                  </div>
                </div>
              </div>
            </div>
            <div style="position:absolute; bottom:8px; right:8px;">
              <v-btn class="btn-primary" @click="clickGetList">
                一覧表示
              </v-btn>
            </div>
          </div>
        </div>
      </details>

      <!-- 一覧部 -->
      <div class="content-card">
        <div
          style="display:flex; justify-content:space-between; align-items:center; margin-bottom:16px; flex-wrap:wrap;"
        >
          <div
            style="display:flex; align-items:center; gap:16px; flex-wrap:wrap;"
          >
            <h2 class="card-title" style="margin:0;">
              避難元避難先一覧（避難所）
            </h2>
          </div>
          <v-card-actions>
            <v-btn class="btn-primary" @click="exportExcel">
              Excel出力
            </v-btn>
          </v-card-actions>
        </div>

        <div class :style="{ height: tableHeight + 'px', overflow: 'auto' }">
          <table class="table adjustment-table fse-table">
            <thead>
              <tr>
                <th colspan="7">自治会</th>
                <th colspan="4">集合場所</th>
                <th colspan="5">避難先</th>
              </tr>
              <tr>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('municip_name')"
                >
                  市町名
                  <span v-if="sortKey === 'municip_name'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th colspan="2">地区等名</th>
                <th colspan="2">自治会名</th>
                <th rowspan="2">人口</th>
                <th rowspan="2">世帯数</th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('fa_name')"
                >
                  施設名
                  <span v-if="sortKey === 'fa_name'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th rowspan="2">住所</th>
                <th colspan="2">原発からの</th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('eva_fa_name')"
                >
                  施設名
                  <span v-if="sortKey === 'eva_fa_name'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th rowspan="2">住所</th>
                <th rowspan="2">収容<br />人数</th>
                <th colspan="2">原発からの</th>
              </tr>
              <tr>
                <th style="cursor:pointer;" @click="sortBy('area_name')">
                  漢字
                  <span v-if="sortKey === 'area_name'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th style="cursor:pointer;" @click="sortBy('area_name_kana')">
                  フリガナ
                  <span v-if="sortKey === 'area_name_kana'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th style="cursor:pointer;" @click="sortBy('autonomy_name')">
                  漢字
                  <span v-if="sortKey === 'autonomy_name'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th
                  style="cursor:pointer;"
                  @click="sortBy('autonomy_name_kana')"
                >
                  フリガナ
                  <span v-if="sortKey === 'autonomy_name_kana'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th>方角</th>
                <th>直線距離</th>
                <th>方角</th>
                <th>直線距離</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="facility in sortedFacilities" :key="facility.key">
                <td>{{ facility.municip_name }}</td>
                <td>{{ facility.area_name }}</td>
                <td>{{ facility.area_name_kana }}</td>
                <td>{{ facility.autonomy_name }}</td>
                <td>{{ facility.autonomy_name_kana }}</td>
                <td>{{ facility.population }}</td>
                <td>{{ facility.households_count }}</td>

                <td>{{ facility.fa_name }}</td>
                <td>{{ facility.fa_address }}</td>
                <td>{{ facility.direction_from_npp }}</td>
                <td>
                  {{ facility.distance_from_npp + " km" }}
                </td>

                <td>{{ facility.eva_fa_name }}</td>
                <td>{{ facility.eva_fa_address }}</td>
                <td>{{ facility.eva_max_capacity }}</td>
                <td>{{ facility.eva_direction_from_npp }}</td>
                <td>
                  {{ facility.eva_distance_from_npp + " km" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <ErrorDialog ref="errorDialog" />
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import ExcelJS from "exceljs";
import messageUtils from "@/mixins/message-utils";
import { ErrorTodoMessages } from "@/js/constants/error-messages";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { ScreenId } from "@/js/value-objects/screen-id";

const adjustmentSystemRepository = RepositoryFactory.get("adjustmentSystem");
const facilitySearchEvaRepository = RepositoryFactory.get("facilitySearchEva");

const LIST_MAX_HEIGHT = 598;
const LIST_MIN_HEIGHT = 290;

export default {
  name: "facilitySearchEva",
  mixins: [messageUtils],
  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    ErrorDialog: () => import("@/components/adjustment/AdErrorDialog"),
    SelectDirection: () => import("@/components/adjustment/SelectDirection")
  },
  data: () => ({
    overlay: false,
    isOpen: true,
    isAuth: false,
    searchFilters: {
      // 避難元関連
      municipName: "",
      areaName: "",
      areaNameKana: "",
      autonomyName: "",
      autonomyNameKana: "",
      populationFrom: null,
      populationTo: null,
      householdsCountFrom: null,
      householdsCountTo: null,
      // 集合場所関連
      faName: "",
      faAddress: "",
      distanceFrom: null,
      distanceTo: null,
      // 避難先関連
      evaFaName: "",
      evaFaAddress: "",
      evaMaxCapacityFrom: null,
      evaMaxCapacityTo: null,
      evaDistanceFrom: null,
      evaDistanceTo: null
    },
    sortKey: "",
    sortOrder: "asc",
    facilityList: []
  }),

  computed: {
    // 検索条件表示非表示の時の一覧の高さ調整
    tableHeight() {
      return this.isOpen ? LIST_MIN_HEIGHT : LIST_MAX_HEIGHT;
    },
    // 一覧のソート
    sortedFacilities() {
      const filtered = this.facilityList;
      if (!this.sortKey) return filtered;

      return [...filtered].sort((a, b) => {
        const aVal = a[this.sortKey];
        const bVal = b[this.sortKey];
        const modifier = this.sortOrder === "asc" ? 1 : -1;

        if (aVal < bVal) return -1 * modifier;
        if (aVal > bVal) return 1 * modifier;
        return 0;
      });
    }
  },

  async mounted() {
    await this.initialize();
  },

  methods: {
    // 初期処理
    async initialize() {
      this.clearMessage();
      this.overlay = true;
      try {
        this.clearSort();

        /* 権限取得 */
        const payload = {
          disasterNo: this.$disaster.disaster_no
        };
        await adjustmentSystemRepository
          .list(ScreenId.SF4101, payload)
          .then(response => {
            this.isAuth = response.data.isAuth;
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      } catch (error) {
        this.handleUpdateError(error);
        console.error("ユーザーの権限取得に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    },
    // 検索条件開閉
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    validateRange(e) {
      const key = e.target.name;
      let txtValue = e.target.value.replace(/[^0-9.]/g, "");
      let value = parseFloat(txtValue);
      if (isNaN(value)) {
        this.searchFilters[key] = txtValue;
      }
      if (value < 0.0) txtValue = 0.0;
      if (value > 9999.9) txtValue = 9999.9;
      this.searchFilters[key] = txtValue;
    },
    validateInteger(e) {
      const key = e.target.name;
      let txtValue = e.target.value.replace(/[^0-9]/g, "");
      let value = parseInt(txtValue);
      if (isNaN(value)) {
        this.searchFilters[key] = txtValue;
        return;
      }
      if (value < 0) txtValue = 0;
      if (value > 9999) txtValue = 9999;
      this.searchFilters[key] = txtValue;
    },
    // 一覧のソート処理
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
    },
    clearSort() {
      this.sortKey = "";
      this.sortOrder = "asc";
    },
    async clickGetList() {
      this.clearMessage();
      await this.getList();
    },
    // 避難元避難先一覧取得
    async getList() {
      this.overlay = true;
      try {
        this.clearSort();
        const directions = await this.$refs.selectDirection.getSelectDirection();
        const evaDirections = await this.$refs.evaSelectDirection.getSelectDirection();

        /* 避難元避難先一覧取得 */
        const payload = {
          // 避難元関連
          municipName: this.searchFilters.municipName,
          areaName: this.searchFilters.areaName,
          areaNameKana: this.searchFilters.areaNameKana,
          autonomyName: this.searchFilters.autonomyName,
          autonomyNameKana: this.searchFilters.autonomyNameKana,
          populationFrom: this.searchFilters.populationFrom,
          populationTo: this.searchFilters.populationTo,
          householdsCountFrom: this.searchFilters.householdsCountFrom,
          householdsCountTo: this.searchFilters.householdsCountTo,
          // 集合場所関連
          faName: this.searchFilters.faName,
          faAddress: this.searchFilters.faAddress,
          distanceFrom: this.searchFilters.distanceFrom,
          distanceTo: this.searchFilters.distanceTo,
          // 避難先関連
          evaFaName: this.searchFilters.evaFaName,
          evaFaAddress: this.searchFilters.evaFaAddress,
          evaMaxCapacityFrom: this.searchFilters.evaMaxCapacityFrom,
          evaMaxCapacityTo: this.searchFilters.evaMaxCapacityTo,
          evaDistanceFrom: this.searchFilters.evaDistanceFrom,
          evaDistanceTo: this.searchFilters.evaDistanceTo,
          directionList: directions,
          evaDirectionList: evaDirections
        };
        await facilitySearchEvaRepository
          .list(ScreenId.SF4101, payload)
          .then(response => {
            this.facilityList = response.data.results;
            this.isOpen = false;
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      } catch (error) {
        this.handleUpdateError(error);
        console.error("避難元避難先一覧（避難所）の取得に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    },
    // EXCEL出力
    async exportExcel() {
      this.overlay = true;
      try {
        if (!this.facilityList.length > 0) {
          await this.$refs.errorDialog.open(ErrorTodoMessages.ERWE48001);
          return;
        }

        /* タイムスタンプ算出 */
        let now = new Date();
        let year = now.getFullYear();
        let month = ("00" + (now.getMonth() + 1)).slice(-2);
        let day = ("00" + now.getDate()).slice(-2);
        let hour = ("00" + now.getHours()).slice(-2);
        let minute = ("00" + now.getMinutes()).slice(-2);
        let timeStamp = year + month + day + hour + minute;
        let timeStamp2 =
          year + "/" + month + "/" + day + " " + hour + ":" + minute;

        // 固定のExcelファイルを取得（publicフォルダに配置されていると仮定）
        const response = await fetch("/template/facility_search_eva_list.xlsx");
        const arrayBuffer = await response.arrayBuffer();

        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);

        const worksheet = workbook.getWorksheet(1); // 最初のシートを取得

        // 罫線スタイルを定義
        const borderStyle = {
          style: "thin",
          color: { argb: "FF000000" }
        };

        //5行目まではヘッダー
        const headerRowCount = 5;
        let rowNo = headerRowCount;
        this.facilityList.forEach(data => {
          rowNo++;
          const row = worksheet.insertRow(rowNo, [
            rowNo - headerRowCount,
            data.municip_name,
            data.area_name,
            data.area_name_kana,
            data.autonomy_name,
            data.autonomy_name_kana,
            Number(data.population),
            Number(data.households_count),

            data.fa_name,
            data.fa_address,
            data.direction_from_npp,
            data.distance_from_npp + " km",

            data.eva_fa_name,
            data.eva_fa_address,
            Number(data.eva_max_capacity),
            data.eva_direction_from_npp,
            data.eva_distance_from_npp + " km"
          ]);

          // 各セルに罫線を設定
          row.eachCell(cell => {
            cell.border = {
              top: borderStyle,
              left: borderStyle,
              bottom: borderStyle,
              right: borderStyle
            };
          });
        });

        const cell = worksheet.getCell("Q2");
        cell.value = "出力日時：" + timeStamp2;

        // 編集済みファイルをダウンロード
        const editedBuffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([editedBuffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "避難元避難先一覧（避難所）_" + timeStamp + ".xlsx";
        link.click();
      } catch (error) {
        console.error("EXCEL出力に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    }
  }
};
</script>
